/**
 * Debounce window (ms) between a keystroke in the header search box and the
 * live suggest request. Fires from the 1st character; empty input shows the
 * default panel instead of querying.
 */
export const searchSuggestDebounceMs = 500;
